import { I18nProvider } from "@/domain/i18n";
import * as React from "react";

export default function Locale({ children }: { children?: React.ReactNode }) {
  return (
    <I18nProvider locale="fr" translations={require("../../public/locales/ch/fr.json")}>
      {children}
    </I18nProvider>
  );
}
